export default "__VITE_ASSET__BN5cIZ2W__"